<script setup>
const props = defineProps({
  for: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <label
    v-if="$slots.default"
    :for="props.for"
    class="text-[11px] font-semibold text-slate-400 uppercase block mb-1"
  >
    <slot />
    <span v-if="required" class="text-red-400 ml-1">*</span>
  </label>
</template>
